import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { IPBillData, IpBill } from './../@core/interfaces/masters/ipbill';
import { IPBillApi } from '../@core/backend/common/api/ipBill.api';
@Injectable()
export class IPBillService extends IPBillData {

  constructor(private api: IPBillApi) {
    super();
  }

  createIPBillMaster(url: string, data: any): Observable<IpBill> {
    return this.api.addIPBillMaster(url, data);
  }
  ipBillMasterList(url: string): Observable<any[]> {
    return this.api.ipBillMasterList(url);
  }
  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }
  updateIPBillMaster(url: string,data: any): Observable<IpBill> {
    return this.api.updateIPBillMaster(url, data);
  }
  cancelBill(url: string,data): Observable<any> {
    return this.api.cancelBill(url, data);
  }
  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }

}
